import { Box, Grid, Stack } from '@eneco/sparky';
import { styled } from '@eneco/sparky/stitches';

import { contentContainerRecipe, ContentContainerVariants } from './Hero.css';

export const config = {
  minHeight: {
    initial: '280px',
    sm: '280px',
    md: '460px',
    lg: '640px',
  },
  offSetContentContainerBottom: '$space$24',
};

export const HeroContainer = styled(Box, {
  position: 'relative',
  width: '100%',
  height: 'auto',

  variants: {
    isVariableWidth: {
      true: {
        '@xl': {
          margin: 'auto',
          maxWidth: '1920px',
          width: '90vw',
        },
      },
    },
    isMinMargin: {
      true: {
        '@xl': {
          marginTop: '-$space$24',
        },
      },
    },
  },
});

export const ImageContainer = styled('div', {
  position: 'absolute',
  left: '0',
  top: '0',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
});

export const RebrandedImageContainer = styled('div', {
  position: 'absolute',
  left: '0',
  top: '0',
  width: '100%',
  height: '100%',

  // Centering with auto margins instead of a transform: a transform would create a stacking
  // context that traps the jss-promo-box placeholder below the sibling ContentContainer,
  // making it unselectable in the Experience Editor.
  '@xl': {
    position: 'absolute',
    left: '0',
    right: '0',
    top: '0',
    width: '80%',
    height: '100%',
    marginInline: 'auto',
    minWidth: '1350px',
    maxWidth: '1353px',
  },
});

// Stacks the promo box on top of the hero image, which shares the same grid cells.
export const StyledGridItem = styled(Grid.Item, {
  position: 'relative',
  zIndex: 2,
});

export const ContentContainer = ({
  hasBottomPlaceholder,
  hasRightPlaceholder,
  isVariableHeight,
  ...rest
}: React.ComponentProps<typeof Stack> & ContentContainerVariants) => (
  <Stack
    className={contentContainerRecipe({ hasBottomPlaceholder, hasRightPlaceholder, isVariableHeight })}
    {...rest}
  />
);

export const LeftPlaceholderBox = styled(Box, {
  position: 'relative',
  zIndex: 2,
  paddingTop: '$space$2',
  paddingBottom: '$space$2',

  '@lg': {
    paddingTop: '0',
    paddingBottom: '0',
  },
});

export const RightPlaceholderBox = styled(Box, {
  position: 'relative',
  minHeight: config.minHeight.initial,
  zIndex: 2,

  '@md': {
    minHeight: config.minHeight.md,
  },

  '@lg': {
    minHeight: 'unset',
  },

  variants: {
    isVariableHeight: {
      true: {
        minHeight: 'unset',
      },
    },
  },
});

HeroContainer.displayName = 'HeroContainer';
ImageContainer.displayName = 'ImageContainer';
StyledGridItem.displayName = 'StyledGridItem';
